import { ReactNode, useState } from 'react'
import { GlobalStorage } from '@/global/storage'

import PreviewModal from '@/components/previewModal'
import { FileItem, parseAttachmentList } from './utils'
import { cn } from '@xhgj/xh-jsutils'
import { Space } from 'antd'
import { downloadFile } from '@/tools'

interface AttachmentPreviewProps {
  // 附件列表的json
  attachment?: string
  splitor?: ReactNode
  clickDownload?: boolean
}

export function AttachmentPreview(props: AttachmentPreviewProps) {
  const { attachment, splitor, clickDownload } = props
  const ossPath = GlobalStorage.getStorageSync('BASEURL')

  // 解析附件列表
  const attachmentList = parseAttachmentList(attachment)

  const [previewVisible, setPreviewVisible] = useState(false)
  const [currentFileUrl, setCurrentFileUrl] = useState('')

  const handleLinkClick = (item: FileItem) => {
    const fileUrl = item.url
    const fullUrl = `${ossPath}${fileUrl}`
    if (clickDownload) {
      downloadFile(fullUrl, item.name)
      return
    }

    setCurrentFileUrl(fullUrl)
    setPreviewVisible(true)
  }

  const handleClosePreview = () => {
    setPreviewVisible(false)
    setCurrentFileUrl('')
  }

  return (
    <>
      <div>
        <Space split={splitor} size={'small'}>
          {attachmentList.map((item, index) => {
            return (
              <span
                key={item.url}
                onClick={() => handleLinkClick(item)}
                className="cursor-pointer primaryBtn"
              >
                {item.name}
              </span>
            )
          })}
        </Space>
      </div>

      <PreviewModal
        open={previewVisible}
        fileUrl={currentFileUrl}
        onCancel={handleClosePreview}
        onOk={handleClosePreview}
      />
    </>
  )
}
import { ReactNode, useState } from 'react'
import { GlobalStorage } from '@/global/storage'

import PreviewModal from '@/components/previewModal'
import { FileItem, parseAttachmentList } from './utils'
import { cn } from '@xhgj/xh-jsutils'
import { Space } from 'antd'
import { downloadFile } from '@/tools'

interface AttachmentPreviewProps {
  // 附件列表的json
  attachment?: string
  splitor?: ReactNode
  clickDownload?: boolean
}

export function AttachmentPreview(props: AttachmentPreviewProps) {
  const { attachment, splitor, clickDownload } = props
  const ossPath = GlobalStorage.getStorageSync('BASEURL')

  // 解析附件列表
  const attachmentList = parseAttachmentList(attachment)

  const [previewVisible, setPreviewVisible] = useState(false)
  const [currentFileUrl, setCurrentFileUrl] = useState('')

  const handleLinkClick = (item: FileItem) => {
    const fileUrl = item.url
    const fullUrl = `${ossPath}${fileUrl}`
    if (clickDownload) {
      downloadFile(fullUrl, item.name)
      return
    }

    setCurrentFileUrl(fullUrl)
    setPreviewVisible(true)
  }

  const handleClosePreview = () => {
    setPreviewVisible(false)
    setCurrentFileUrl('')
  }

  return (
    <>
      <div>
        <Space split={splitor} size={'small'}>
          {attachmentList.map((item, index) => {
            return (
              <span
                key={item.url}
                onClick={() => handleLinkClick(item)}
                className="cursor-pointer primaryBtn"
              >
                {item.name}
              </span>
            )
          })}
        </Space>
      </div>

      <PreviewModal
        open={previewVisible}
        fileUrl={currentFileUrl}
        onCancel={handleClosePreview}
        onOk={handleClosePreview}
      />
    </>
  )
}
